import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';

class LoginForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    _error: PropTypes.string,
    submitting: PropTypes.bool.isRequired,
  }
  static validate = (values) => {
    const errors = {};

    if (!values.email) {
      errors.email = 'Required';
    }
    if (!values.password) {
      errors.password = 'Required';
    }

    return errors;
  }

  renderTextField = props => (
    <TextField hintText={props.label} floatingLabelText={props.label} errorText={props.touched && props.error} {...props} />
  );

  render() {
    const { _error, handleSubmit, submitting } = this.props;
    const buttonText = (submitting) ? 'Logging In...' : 'Login';
    return (
      <div className="row">
        <div className="col s12 center-align">
          <form onSubmit={handleSubmit}>
            {_error &&
            <div className="row">
              <div className="col s12">
                <div>{_error}</div>
              </div>
            </div>
            }
            <div className="row">
              <div className="col s12">
                <Field type="email" name="email" component={this.renderTextField} floatingLabelText="Email" />
              </div>
            </div>
            <div className="row">
              <div className="col s12">
                <Field type="password" name="password" component={this.renderTextField} floatingLabelText="Password" />
              </div>
            </div>
            <div className="row">
              <div className="col s12">
                <RaisedButton onClick={handleSubmit} disabled={submitting} type="submit">{buttonText}</RaisedButton>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: 'login',
  validate: LoginForm.validate,
})(LoginForm);


// WEBPACK FOOTER //
// ./src/components/Login/index.js